import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';
import { headerSharedStyles } from './Header.styles';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useAppHeaderProfileMenuStyles = makeStyles(() => ({
  popper: {
    ...headerSharedStyles.popper,
  },

  paper: {
    marginTop: spacing.xs,
    padding: spacing.sm,
    borderRadius: radius.sm,
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.white,
    boxShadow: '0 4px 16px rgba(14, 18, 71, 0.08)',
    minWidth: 180,
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },

  item: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.sm,
    width: '100%',
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.textBody,
    lineHeight: 'normal',
    textAlign: 'left',
    '&:hover': {
      opacity: 0.8,
    },
  },

  itemIcon: {
    width: 16,
    height: 16,
    color: colors.textBody,
    flexShrink: 0,
  },
}));
